import { App } from "@capacitor/app";
import React, { useEffect } from "react";
import { DebugBadge, DebugKeyValue } from "./debug.styles";

interface AppInfo {
  name: string;
  id: string;
  build: string;
  version: string;
}

const DebugCapInfo = () => {
  const [appInfo, setAppInfo] = React.useState<AppInfo | null>(null);
  const [error, setError] = React.useState<string | null>(null);

  useEffect(() => {
    void App.getInfo()
      .then((info) => {
        setAppInfo(info);
      })
      .catch(() => {
        setError("Not available (web)");
      });
  }, []);

  if (error) {
    return (
      <DebugKeyValue>
        <span className="key">Status</span>
        <span className="value">
          <DebugBadge variant="info">{error}</DebugBadge>
        </span>
      </DebugKeyValue>
    );
  }

  if (!appInfo) {
    return (
      <DebugKeyValue>
        <span className="key">Status</span>
        <span className="value">Loading...</span>
      </DebugKeyValue>
    );
  }

  return (
    <div>
      <DebugKeyValue>
        <span className="key">Name</span>
        <span className="value">{appInfo.name}</span>
      </DebugKeyValue>
      <DebugKeyValue>
        <span className="key">ID</span>
        <span className="value mono" style={{ fontSize: "11px" }}>
          {appInfo.id}
        </span>
      </DebugKeyValue>
      <DebugKeyValue>
        <span className="key">Version</span>
        <span className="value">
          <DebugBadge variant="success">{appInfo.version}</DebugBadge>
        </span>
      </DebugKeyValue>
      <DebugKeyValue>
        <span className="key">Build</span>
        <span className="value mono">{appInfo.build}</span>
      </DebugKeyValue>
    </div>
  );
};

export default DebugCapInfo;
